import { render, staticRenderFns } from "./parent.vue?vue&type=template&id=4a915ee4&scoped=true&"
import script from "./parent.vue?vue&type=script&lang=js&"
export * from "./parent.vue?vue&type=script&lang=js&"
import style0 from "./parent.vue?vue&type=style&index=0&id=4a915ee4&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a915ee4",
  null
  
)

export default component.exports